
module.filter('studentStatus', function() {
    return function(student) {
        if (!student.has_enrollment) {
            return [student.grant_year, student.slot_type.toUpperCase(),
                    'Member'].join(' ')
        } else if (!student.exited) {
            return 'Active';
        } else if (student.in_followup) {
            return 'In Followup';
        } else if (student.successful) {
            return 'Successful Exit';
        } else if (student.exit_reason === 'deceased') {
            return 'Deceased';
        } else  if (student.exited) {
            return 'Unsuccessful Exit';
        }
    };
});
